import React, { useEffect, useState } from "react";
import GuideListTable, {
  AvatarCell,
  SelectColumnFilter,
  StatusPill,
  ImageCell,
  ProductImageCell,
  NumberCell,
} from "./GuideListTable"; // new

function GuideListData() {
  const data = [
    {
      id: "1",
      details:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.",
      status: "Repair",
      items: "Massgaing Chair",
    },
    {
      id: "1",
      details: "Warehouse 2",
      status: "Packed",
      items: "Massgaing Chair",
    },
    {
      id: "1",
      details: "Warehouse 2",
      status: "QC",

      items: "Massgaing Chair",
    },
    {
      id: "1",
      details: "RMS 40 steel lorries",
      status: "Testing",
      items: "Massgaing Chair",
    },
  ];

  const columns = React.useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        Cell: NumberCell,
      },
      {
        Header: "Product",
        accessor: "product",
        Cell: ProductImageCell,
      },
      {
        Header: "Details",
        accessor: "details",
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: StatusPill,
      },
      {
        Header: "Items",
        accessor: "items",
      },
      {
        Header: "Actions",
        accessor: "action",
        Cell: (value) => (
          <div className="flex flex-wrap">
            <div className=" text-gray-900 font-medium ">
              {" "}
                <button className="float-right mt-3">
                  <svg
                    width="22"
                    height="20"
                    viewBox="0 0 22 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_807_4358)">
                      <path
                        d="M6.94498 18.8033L0.788086 20L2.03052 14.0625L6.94498 18.8033ZM3.25222 12.8833L8.16668 17.6242L21.5242 4.74083L16.6089 0L3.25222 12.8833Z"
                        fill="#1F78B4"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_807_4358">
                        <rect
                          width="20.7361"
                          height="20"
                          fill="white"
                          transform="translate(0.787109)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </button>
            </div>
          </div>
        ),
      },
      {
        Header: "Actions1",
        accessor: "action1",
        Cell: (value) => (
          <div className="flex flex-wrap">
            <div className=" text-gray-900 font-medium ">
              {" "}
                <button className="float-right mt-3">
                  <svg
                    width="21"
                    height="20"
                    viewBox="0 0 21 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2.85059 18.3334V1.66669L18.4026 10L2.85059 18.3334Z"
                      fill="#1F78B4"
                    />
                  </svg>
                </button>
            </div>
          </div>
        ),
      },
    ],
    []
  );

  return (
    <div className="mb-8 pb-4">
      <main className="max-w-full min-h-full px-4 sm:px-6 lg:px-8 pt-4">
        <div className="-mt-10">
          <GuideListTable
            columns={columns}
            data={data == undefined ? [] : data}
            text="Undefined"
          />
        </div>
      </main>
    </div>
  );
}

export default GuideListData;
